import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import {projectsData} from '../../../src/profile'
import './Projects.css'
import ProjectCard from './ProjectCard'

function Projects() {
    return (
        <div className='section-container'>
           <Header
                heading='My Projects.'
                details="Here are some projects I've worked on, do check them out"
           /> 

           <div className='project-cards-container'>
          {projectsData.map(({projectName,started,projectDescription,imageUrl,projectUrl}) => {
              return (<ProjectCard 
                  projectName={projectName}
                  started={started}
                  projectDescription={projectDescription}
                  projectUrl={projectUrl}
                  imageUrl={imageUrl}
              />);
          })}
          </div>

            <Footer
                title='Check out my 👉 '
                link='My Personal Project!'
                toAdress='/personal-projects'
        />
        </div>
    )
}

export default Projects
